<div class="gallery-thumb-container">
  <div
    class="row  justify-content-around mx-3"
    *ngIf="thumbArray && thumbArray.length > 0"
  >
    <div
      class=" col-lg-2 col-md-4 col-6"
      *ngFor="let img of thumbArray; let i = index"
    >
      <div
        class="img-thumb mx-auto mb-2"
        [style.background-image]="img"
        (click)="openGallery(i)"
      ></div>
    </div>
  </div>
</div>
<div class="gallery-container" *ngIf="galleryOpened">
  <i class="gallery-btn fas fa-times" (click)="close()"></i>
  <div class="row">
    <div class="col-1 align-self-center text-center">
      <i
        *ngIf="picNum > 1"
        class="gallery-btn fas fa-arrow-left"
        (click)="prev()"
      ></i>
    </div>
    <div class="col-10">
      <div class="open-img" [style.background-image]="selectedImg"></div>
    </div>
    <div class="col-1 align-self-center text-center">
      <i
        *ngIf="picNum > 1"
        class="gallery-btn fas fa-arrow-right"
        (click)="next()"
      ></i>
    </div>
  </div>
</div>
